import { paths } from '~/../shared/routing';
import DetectPlatform from '../utils/DetectPlatform';

import getConfig from 'next/config';
import { linksToMobileApps } from '~/components/utils/config';
import { getAliasFromPath, getPath, getRouteFromAlias, languageToCountryCode } from '../../../shared/utils';
import { useContext } from 'react';
import { LangContext } from '~/providers/LangProvider';
import { defaultCountry } from '~/providers/LangProvider/countryUtils';

const { publicRuntimeConfig } = getConfig();

class RedirectToApp {
    constructor(userAgent, utm = '', campaign = 'no_campaign') {
        this.detectPlatform = new DetectPlatform(userAgent);
        this.utm = utm;
        this.campaign = campaign;

        if (!this.utm) {
            this.utm = (window.location.pathname.match(/[^/]+(\/|$)/g) || [
                '',
            ])[0];
        }

        this.redirect();
    }

    redirect() {
        let redirectUrl = '';

        if (this.detectPlatform.isAndroid()) {
            redirectUrl = linksToMobileApps.android;
        } else if (this.detectPlatform.isAppleMobileDevice()) {
            redirectUrl =
                'http://click.google-analytics.com/redirect?' +
                'tid=' +
                publicRuntimeConfig.GA_UA + // Google Analytics Tracking ID.
                '&idfa=' +
                '' + // Identifier for Advertising (IDFA)
                '&aid=' +
                linksToMobileApps.ios_app_id + // App ID.
                '&cs=qrcode' + // Campaign source.
                '&cm=' +
                this.utm + // Campaign medium.
                '&cn=' +
                this.campaign + // Campaign name.
                `&url=${linksToMobileApps.ios}`; // Redirect URL to iTunes
        } else {
            // TODO ano je to humus
            const lang = window.location.pathname.slice(1,3)
            const country = languageToCountryCode[lang] || defaultCountry
            redirectUrl = '/' + lang + getAliasFromPath(getPath(paths.personal, country), lang) + window.location.search;
        }

        window.location = redirectUrl;
    }
}

export default RedirectToApp;
